import React from 'react';
import { SortAscendingOutlined, SortDescendingOutlined } from '@ant-design/icons';
import PartStore from '../stores/PartStore';
import { observer } from 'mobx-react';

export const SortFiles = observer(({ fileType }: { fileType: '3D File' | '2D File' | 'Additional File' }) => {
    const isActive = PartStore.sortedBy === fileType;
    const isDesc = isActive && PartStore.sortOrder === 'desc';

    const Icon = isDesc ? SortDescendingOutlined : SortAscendingOutlined;

    return (
        <div
            className="flex m-auto items-center justify-center"
            style={{
                maxWidth: 200,
            }}
        >
            <div>{fileType}s</div>
            <div className="flex flex-col ml-2" title={isDesc ? 'Sorted Z–A (click for A–Z)' : 'Sorted A–Z (click for Z–A)'}>
                <Icon
                    className="text-lg cursor-pointer"
                    onClick={() => PartStore.sortBy(fileType)}
                    style={{
                        color: isActive ? '#16a34a' : '#dc2626',
                    }}
                />
            </div>
        </div>
    );
});
